import 'intersection-observer';
import smoothscroll from 'smoothscroll-polyfill';
import 'whatwg-fetch';

// Number.parseInt polyfill
if (Number.parseInt === undefined) Number.parseInt = window.parseInt;

// Number.parseFloat polyfill
if (Number.parseFloat === undefined) Number.parseFloat = window.parseFloat;

smoothscroll.polyfill();
